import { TemplatePortal } from '@angular/cdk/portal';
import {
  AfterViewInit,
  Component,
  computed,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { FilePanelService } from '@lib/components/document-viewer/file-viewer/file-panel.service';
import { FileViewerComponent } from '@lib/components/document-viewer/file-viewer/file-viewer.component';
import { FiltrerInvestisseursComponent } from '@lib/components/filtrer-investisseurs/filtrer-investisseurs.component';
import { QPIViewerPageComponent } from '@lib/components/investisseur-details/tabs/connaissance-client/steps/qpi-step/qpi-viewer-page/qpi-viewer-page.component';
import { SignataireDetailsComponent } from '@lib/components/signature/signataire-details/signataire-details.component';
import { SignaturePanelService } from '@lib/components/signature/signature-panel.service';
import { AuthService } from '@lib/services/auth-service.service';
import { ChunkErrorGuardService } from '@lib/services/chunk-error-guard.service';
import { FiltrerInvestisseursPanelService } from '@lib/services/filtrer-investisseurs/filtrer-investisseurs-panel.service';
import { LoadingService } from '@lib/services/loading.service';
import { QpiViewerPanelService } from '@lib/services/qpi-viewer-panel.service';
import { SwUpdateService } from '@lib/services/sw-update.service';
import { MenuNode } from 'omnium-ui/shared';
import { SHARED_IMPORTS } from 'projects/minotaure-lib/src/shared-imports';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SHARED_IMPORTS,
    RouterModule,
    FiltrerInvestisseursComponent,
    QPIViewerPageComponent,
    SignataireDetailsComponent,
    FileViewerComponent,
  ],
})
export class AppComponent implements OnInit, AfterViewInit {
  private updateService = inject(SwUpdateService); // juste pour instancier le service et lancer la logique de vérification des mises à jour
  private chunkGardService = inject(ChunkErrorGuardService); // juste pour instancier le service et lancer la logique de surveillance des erreurs de chargement de composants
  protected loadingService = inject(LoadingService);
  protected authService = inject(AuthService);
  private readonly filterInvestisseursPanelService = inject(FiltrerInvestisseursPanelService);
  private readonly qpiViewerPanelService = inject(QpiViewerPanelService);
  private readonly signaturePanelService = inject(SignaturePanelService);
  private readonly filePanelService = inject(FilePanelService);
  private readonly _viewContainerRef = inject(ViewContainerRef);
  logoUrl = 'assets/LogoAppProxeema_nav.svg';

  @ViewChild('filtrerPortalContent') filtrerPortalContent: TemplateRef<unknown>;
  @ViewChild('qpiViewerPortalContent') qpiViewerPortalContent: TemplateRef<unknown>;
  @ViewChild('signatairePortalContent') signatairePortalContent: TemplateRef<unknown>;
  @ViewChild('filePortalContent') filePortalContent: TemplateRef<unknown>;

  filterPortal: TemplatePortal;
  qpiViewerPortal: TemplatePortal;
  signatairePortal: TemplatePortal;
  filePortal: TemplatePortal;

  currentVersion = environment.appVersion;
  // menu = signal<MenuNode[]>([]);

  migrationViewerMenu: MenuNode[] = [
    {
      name: 'Migrations Consultants',
      routeLink: '/migration-consultant',
      icon: 'group',
    },
  ];
  migrationAdminMenu: MenuNode[] = [
    {
      name: 'Migrations Consultants',
      routeLink: '/migration-consultant',
      icon: 'group',
    },
    {
      name: 'Vagues de migration',
      routeLink: '/wave-stats',
      icon: 'tsunami',
    },
    {
      name: 'Recalculs financiers',
      routeLink: '/financial-recalculation-dashboard',
      icon: 'calculate',
    },
  ];
  backOfficeMenu: MenuNode[] = [
    {
      name: 'Investisseurs',
      routeLink: '/investisseurs',
      icon: 'people',
    },
    {
      name: 'Fiche Conseil',
      routeLink: '/fiche-conseil',
      icon: 'folder_shared',
    },
  ];
  contratViewerMenu: MenuNode[] = [
    {
      name: 'Contrats Stellium',
      routeLink: '/contrats-stellium',
      icon: 'chart_data',
    },
  ];
  userName = '';
  userMenu: MenuNode[] = [
    {
      name: 'Se déconnecter',
      icon: 'power_settings_new',
      action: () => {
        this.authService.logout();
      },
    },
  ];
  menu = computed<MenuNode[]>(() => {
    const isContratViewer = this.authService.isContratViewer();
    const isMigrationViewer = this.authService.isMigrationViewer();
    const isAdmin = this.authService.isAdmin();
    const isBackOffice = this.authService.isBackOffice();

    const backOfficeMenu: MenuNode[] = [];
    if (isAdmin) {
      backOfficeMenu.push(...this.migrationAdminMenu);
    }
    if (isMigrationViewer && !isAdmin) {
      backOfficeMenu.push(...this.migrationViewerMenu);
    }
    if (isBackOffice) {
      backOfficeMenu.push(...this.backOfficeMenu);
    }
    if (isContratViewer) {
      backOfficeMenu.push(...this.contratViewerMenu);
    }

    return backOfficeMenu;
  });
  constructor() {}

  onHelpClick() {
    window.open('https://www.google.fr/', '_blank');
  }

  ngOnInit(): void {
    this.authService
      .login()
      .then(() => {
        const userInfo = this.authService.getUserInfo();
        this.userName = userInfo.fullName;
      })
      .catch((error: unknown) => {
        console.log('Login failed with error: ', error);
      });
  }

  ngAfterViewInit(): void {
    this.filterPortal = new TemplatePortal(this.filtrerPortalContent, this._viewContainerRef);
    this.filterInvestisseursPanelService.registerPortal(this.filterPortal);
    this.qpiViewerPortal = new TemplatePortal(this.qpiViewerPortalContent, this._viewContainerRef);
    this.qpiViewerPanelService.registerPortal(this.qpiViewerPortal);
    this.signatairePortal = new TemplatePortal(this.signatairePortalContent, this._viewContainerRef);
    this.signaturePanelService.registerPortal(this.signatairePortal);
    this.filePortal = new TemplatePortal(this.filePortalContent, this._viewContainerRef);
    this.filePanelService.registerPortal(this.filePortal);
  }
}
